
'use strict';

define('component!ContextualHelpPaneComponent',['require','translate','prop-types','react','underscore','lib/react/React.PodioView','component!Raw','component!HelpPane','component!Spinner','lib/Podio.Utils','lib/Podio.Bootstrap','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.UI','lib/GlobalEventBus','lib/backbone/Backbone.Mixins.Transport.Rails','mixins/TrackingEventMixin','services/ContractService'],function (require) {
  'use strict';

  var t = require('translate');
  var PropTypes = require('prop-types');
  var React = require('react');
  var _ = require('underscore');
  var PodioView = require('lib/react/React.PodioView');

  var Raw = require('component!Raw');
  var HelpPaneComponent = require('component!HelpPane');
  var SpinnerComponent = require('component!Spinner');

  var utils = require('lib/Podio.Utils');
  var bootstrap = require('lib/Podio.Bootstrap');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var ui = require('lib/Podio.UI');
  var globalEvent = require('lib/GlobalEventBus');

  var RailsAPI = require('lib/backbone/Backbone.Mixins.Transport.Rails');

  var TrackingEventMixin = require('mixins/TrackingEventMixin');

  var ContractService = require('services/ContractService');

  var BLACKLISTED_SECTION_IDS = [200260928];

  var ContextualHelpPaneComponent = PodioView.extend({
    displayName: 'ContextualHelpPaneComponent',

    mixins: [TrackingEventMixin],

    propTypes: {
      eventBus: PropTypes.object,
      model: PropTypes.object
    },

    getDefaultProps: function getDefaultProps() {
      return {
        eventBus: void 0,
        elmHeaderHelp: void 0,
        hasFeatureTour: bootstrap.hasBootstrapData('FeatureTourSettings')
      };
    },

    getInitialState: function getInitialState() {
      this.input = React.createRef();
      return {
        isOpen: false,
        isInitial: true,
        helpData: {
          global_help_section: {},
          global_help_videos: [],
          topics: []
        },
        searchValue: '',
        isSearching: false,
        zendeskArticles: []
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var _this2 = this;

      ContractService.getContracts();

      var url = routes.show_global_help_pane_path({
        current_section: this.props.elmHeaderHelp.data('section'),
        global_help_controller_section: this.props.elmHeaderHelp.data('controller-section')
      });

      transport.getJSON(url).done((function (response) {
        this.setState({
          helpData: response.data
        });
      }).bind(this));

      this.props.eventBus.on('helpPane:afterOpened', (function () {
        var _this = this;

        this.setState({ isOpen: true }, function () {
          _this.input.current.focus();
        });
      }).bind(this));
      this.props.eventBus.on('helpPane:afterClosed', (function () {
        this.setState({ isOpen: false });
      }).bind(this));

      this.setupTracking({
        type: 'help',
        subtype: 'contextual_help_pane'
      });

      this._search = _.debounce(function (value) {
        _this2.setState({
          searchValue: value,
          isSearching: value.length > 0 && _this2.state.searchValue !== value
        }, function () {
          if (_this2.state.isSearching) {
            _this2.setState({
              zendeskArticles: []
            });

            RailsAPI.request('GET', '/_json/help/search?query={0}'.format(_this2.state.searchValue)).done(function (response) {
              _this2.setState({ isSearching: false });

              if (_this2.state.zendeskArticles.length > 0 && response.data.results.length === 0) {
                return;
              }

              _this2.setState({
                zendeskArticles: response.data.results.filter(function (result) {
                  return !_.contains(BLACKLISTED_SECTION_IDS, result.section_id);
                })
              });
            });
          }
        });
      }, 300);
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.eventBus.off(null, null, this);
    },

    render: function render() {
      this._ensureHeaderHelpElementState();

      return React.createElement(
        HelpPaneComponent,
        { variant: 'contextual-help', openImmediately: true, isOpen: this.state.isOpen, eventBus: this.props.eventBus },
        React.createElement(
          'div',
          { className: 'contextual-help-pane-component' },
          React.createElement(
            'div',
            { className: 'image-block contextual-help-pane-search' },
            React.createElement(
              'div',
              { className: 'img' },
              React.createElement(
                'div',
                { className: 'icon icon-16 img' },
                React.createElement('div', { className: 'icon-nav icon-help-pane-search' })
              )
            ),
            React.createElement(
              'div',
              { className: 'bd' },
              React.createElement('input', { onKeyUp: this.handleInput, ref: this.input, type: 'text', name: 'query', placeholder: t('Type your question and hit ‘Enter’ #help.contextual'), autoComplete: 'off' })
            )
          ),
          this.state.isSearching || this.state.zendeskArticles.length > 0 ? this._renderSearchResults() : this._renderEntry()
        )
      );
    },

    _renderSearchResults: function _renderSearchResults() {
      return React.createElement(
        'div',
        { className: 'entry-text-wrapper' },
        React.createElement(
          'h2',
          null,
          React.createElement(
            Raw,
            null,
            t('Search results #help.contextual')
          ),
          this.state.isSearching ? React.createElement(SpinnerComponent, { loader: 'dark', useWrapper: false }) : null
        ),
        React.createElement(
          'div',
          null,
          this.state.zendeskArticles.length === 0 ? React.createElement(
            'li',
            null,
            'Searching..'
          ) : null,
          _.take(this.state.zendeskArticles, 10).map(function (article, index) {
            return React.createElement(
              'li',
              { key: index, className: '', title: article.title },
              React.createElement(
                'a',
                { href: article.html_url, target: '_blank' },
                article.title
              )
            );
          })
        ),
        this._renderContactSupport()
      );
    },

    _renderEntry: function _renderEntry() {
      return React.createElement(
        'div',
        { className: 'entry-text-wrapper' },
        React.createElement(
          'h2',
          null,
          React.createElement(
            Raw,
            null,
            t('Help & Support #pane.contextual_help')
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'li',
            { className: 'strong' },
            t('Videos and forums #help.contextual')
          ),
          this.state.helpData.global_help_videos.map(function (video, index) {
            return React.createElement(
              'li',
              { key: index, className: 'video-link youtube-link', 'data-video': video.url, title: video.title },
              React.createElement(
                'a',
                { href: video.url, target: '_blank' },
                video.title
              )
            );
          }),
          React.createElement(
            'li',
            null,
            React.createElement(
              'a',
              { href: 'https://support.sharefile.com', target: '_blank' },
              t('General help forum #help.contextual')
            )
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'li',
            { className: 'strong' },
            t('Popular topics #help.contextual')
          ),
          this.state.helpData.topics.map(function (topic, index) {
            return React.createElement(
              'li',
              { key: index, className: 'topic-link' },
              React.createElement(
                'a',
                { href: topic.url, target: '_blank' },
                topic.title
              )
            );
          })
        ),
        this.props.hasFeatureTour ? this._renderTour() : null,
        this._renderProductNews(),
        React.createElement(
          'div',
          null,
          React.createElement(
            'li',
            { className: 'strong' },
            t('Need more functionality? #help.contextual')
          ),
          React.createElement(
            'li',
            { className: 'extensions-link' },
            React.createElement(
              'a',
              { href: routes.extensions_path({ format: 'html' }) },
              t('Browse extensions #help.contextual')
            )
          ),
          React.createElement(
            'li',
            { className: 'shortcuts-link' },
            React.createElement(
              'a',
              { href: 'https://docs.sharefile.com/en-us/podio/using-podio/general-features/keyboard-shortcuts', target: '_blank', onClick: this.handleShortcutLinkClick },
              t('Keyboard shortcuts #help.contextual')
            )
          )
        ),
        this._renderContactSupport()
      );
    },

    handleShortcutLinkClick: function handleShortcutLinkClick(syntheticEvent) {
      if (syntheticEvent.metaKey || syntheticEvent.ctrlKey) {
        return;
      }

      syntheticEvent.preventDefault();

      globalEvent.trigger('shortcut:help');
    },

    _renderTour: function _renderTour() {
      var bootstrapData = bootstrap.getBootstrapData('FeatureTourSettings');
      if (!_.isEmpty(bootstrapData)) {
        return React.createElement(
          'div',
          null,
          React.createElement(
            'li',
            { className: 'strong' },
            t('Tour #help.contextual')
          ),
          React.createElement(
            'li',
            { className: 'forum-link' },
            React.createElement(
              'a',
              { href: utils.addQueryString(location.href, 'tour', 'true') },
              t('Start tour #help.contextual')
            )
          )
        );
      } else {
        return null;
      }
    },

    _renderProductNews: function _renderProductNews() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'li',
          { className: 'strong' },
          t("What's new in Podio #help.contextual")
        ),
        React.createElement(
          'li',
          null,
          React.createElement(
            'a',
            { href: 'https://support.sharefile.com/s/topic/0TODn000000ghshOAA/podio-product-news', target: '_blank' },
            t('Product News #help.contextual')
          )
        )
      );
    },

    _renderContactSupport: function _renderContactSupport() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'li',
          { className: 'strong' },
          t("Can't find the answer? #help.contextual")
        ),
        React.createElement(
          'li',
          { className: 'zendesk-link' },
          React.createElement(
            'a',
            { href: 'https://support.sharefile.com', target: '_blank' },
            t('Help Center and contact support #help.contextual')
          )
        )
      );
    },

    _ensureHeaderHelpElementState: function _ensureHeaderHelpElementState() {
      this.props.elmHeaderHelp.css({
        display: this.state.isOpen ? 'none' : 'inline-block'
      });
    },

    handleInput: function handleInput(syntheticEvent) {
      if (syntheticEvent.keyCode === ui.KeyCodes.Esc) {
        syntheticEvent.preventDefault();

        this.setState({
          isOpen: false,
          searchValue: '',
          zendeskArticles: []
        });

        this.input.current.blur();
      } else if (syntheticEvent.keyCode === ui.KeyCodes.Return) {
        this._search(syntheticEvent.target.value);
      }

      if (syntheticEvent.target.value.length === 0) {
        this.setState({
          searchValue: '',
          isSearching: false,
          zendeskArticles: []
        });
      } else {
        this._search(syntheticEvent.target.value);
      }
    }
  });

  return ContextualHelpPaneComponent;
});
